import { Modal, NeutralButton, PrimaryButton, RadioGroup, SecondaryButton } from '@systemeio/ui'
import { MailingId } from 'modules/mailing/types/mailing-interface'
import { useGetNewsletterView } from 'modules/newsletters/single/hooks/use-get-newsletter-view'
import { NewsletterId } from 'modules/newsletters/single/types/newsletter-interface'
import { useCancelSplitTest } from 'modules/newsletters/split-test/hooks/use-cancel-split-test'
import { NewsletterSplitTestInterface } from 'modules/newsletters/split-test/types/newsletter-split-test-interface'
import { useRouter } from 'next/router'
import React, { useState } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

interface StopSplitTestModalProps {
  mailingSplitTest: NewsletterSplitTestInterface
  newsletterId: NewsletterId
}

export const CancelSplitTestModal = ({
  mailingSplitTest,
  newsletterId,
}: StopSplitTestModalProps) => {
  const { t } = useLocoTranslation()
  const router = useRouter()

  const [opened, setOpened] = useState<boolean>(false)
  const [selected, setSelected] = useState<MailingId>(mailingSplitTest.mailingVariantA.id)

  const { cancelSplitTest, isFetching } = useCancelSplitTest()
  const { mutateNewslettersData } = useGetNewsletterView({
    newsletterId,
  })

  const customerTypeData = [
    {
      id: mailingSplitTest.mailingVariantA.id,
      caption: t('dashboard.newsletter_editor.split_test.variant_a'),
    },
    {
      id: mailingSplitTest.mailingVariantB.id,
      caption: t('dashboard.newsletter_editor.split_test.variant_b'),
    },
  ]
  const handelCancelSplitTest = async () => {
    try {
      await cancelSplitTest(newsletterId, selected)
      await mutateNewslettersData()
      await router.replace(
        {
          pathname: router.asPath.split('?variant')[0],
        },
        undefined,
        {
          shallow: true,
        },
      )
      setOpened(false)
    } catch (e) {
      throw e
    }
  }

  const onClose = () => {
    setOpened(false)
    setSelected(mailingSplitTest.mailingVariantA.id)
  }

  return (
    <>
      <NeutralButton onClick={() => setOpened(true)}>
        <span>{t('dashboard.newsletter_editor.split_test.stop_modal_button')}</span>
      </NeutralButton>
      <Modal
        isCentered
        opened={opened}
        onClose={() => onClose()}
        title={t('dashboard.newsletter_editor.split_test.stop_modal_title')}
      >
        <div className={'flex flex-col gap-6 lg:gap-10'}>
          <div className="flex flex-col items-center gap-6">
            <p className="text-text-primary text-base">
              {t('dashboard.newsletter_editor.split_test.stop_modal_text')}
            </p>
            <RadioGroup
              className={'items-center'}
              label={t('dashboard.newsletter_editor.split_test.save_and_test.selected_variant')}
              selected={selected}
              options={customerTypeData}
              onChange={value => setSelected(value)}
            />
          </div>
          <div className={'flex justify-center gap-4'}>
            <SecondaryButton
              className={'w-full'}
              onClick={() => onClose()}
              width={'large'}
              disabled={isFetching}
            >
              {t('global.cancel')}
            </SecondaryButton>
            <PrimaryButton
              className={'w-full'}
              width={'large'}
              onClick={() => handelCancelSplitTest()}
              isFetching={isFetching}
            >
              {t('global.save')}
            </PrimaryButton>
          </div>
        </div>
      </Modal>
    </>
  )
}
